export const DARKMODE_LOCAL_STORAGE_KEY = 'TracefyDarkMode'
export const CUSTOMER_CONSENT_COOKIE_PREFIX = 'TracefyCustomerConsentToken'
export const STATIC_WEB_CONTENT_URL = 'https://static-web-content.tracefy.net/vue-portal-v1'

export const testEnvironments = ['localhost', 'acc.', 'staging.']
